/* global google , __CLIENT__ */

import React, { useEffect } from 'react';
import exact from 'prop-types-exact';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const useSearchQuery = () => {
    const search = useLocation().search;
    const urlSearchParams = new URLSearchParams(search);
    const searchQuery = urlSearchParams.get('q');

    return searchQuery;
};

const SearchResults = () => {
    const currentSearch = useSearchQuery();

    const _CSECallback = () => {
        if (document.readyState === 'complete') {
            // Document is ready when CSE element is initialized.
            // Render an element with both search box and search results in div with id 'test'.
            google.search.cse.element.render(
                {
                    div: 'SearchResultsContainer',
                    tag: 'searchresults-only',
                    gname: 'searchResult',
                },
            );
        } else {
            // Document is not ready yet, when CSE element is initialized.
            google.setOnLoadCallback(() => {
                // Render an element with both search box and search results in div with id 'sea'.
                google.search.cse.element.render(
                    {
                        div: 'SearchResultsContainer',
                        tag: 'searchresults-only',
                        gname: 'searchResult',
                    },
                );
            }, true);
        }
    };

    const _initializeCSE = () => {
        if (__CLIENT__) {
            // eslint-disable-next-line no-prototype-builtins
            if (typeof google === 'undefined' || !google.hasOwnProperty('search')) {
                const cx = '016811436202189383163:ha8tfvnddec';

                window.__gcse = {
                    parsetags: 'explicit',
                    callback: _CSECallback,
                };

                const tag = document.createElement('script');

                tag.async = false;

                tag.src = `https://cse.google.com/cse.js?cx=${cx}`;

                document.body.appendChild(tag);
            } else {
                // this happens when going back to the search page after it had already loaded once
                _CSECallback();
            }
        }
    };

    const _handleCSE = (search) => {
        typeof google !== 'undefined' && google.search?.cse?.element?.getElement('searchResult')?.execute(search);
    };

    useEffect(() => {
        if (currentSearch) {
            _handleCSE(currentSearch);
        } else {
            // @TODO remove the results always when the currentSearch changes, not just on enter and if it is empty
            typeof google !== 'undefined' && google.search?.cse?.element?.getElement('searchResult')?.clearAllResults();
        }
    }, [currentSearch]);

    useEffect(() => {
        _initializeCSE();

        if (currentSearch) {
            _handleCSE(currentSearch); // set by the constructor
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div className="SearchResults tw-container tw-m-auto tw-px-5">
            <h2 className="tw-capitalize">
                {currentSearch}
            </h2>
            <div className="SearchResultsContainer" id="SearchResultsContainer" />
        </div>
    );
};

SearchResults.propTypes = exact({

});


export default SearchResults;
